import { Alert, AlertIcon, useToast } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { ContextApp } from "../../shared/ContextApp";

export const useCheckAddressForUser = () => {
  const { user } = useContext(ContextApp);
  const navigate = useNavigate();
  useEffect(() => {
    if (user) {
      if (user.role === "customer")
        if (!user.address?.length) {
          navigate("/address");
        }
    }
  }, [user]);
};
